<mat-card-header [ngClass]="error ? 'system-message error' : ''">
  <mat-card-title class="nsc-card-title">
    @switch (headingLevel) {
      @case (1) {
        <h1>
          <ng-content></ng-content>
          @if (note) {
            <span class="nsc-card-title__note mat-caption">{{ note }}</span>
          }
        </h1>
      }
      @case (2) {
        <h2>
          <ng-content></ng-content>
          @if (note) {
            <span class="nsc-card-title__note mat-caption">{{ note }}</span>
          }
        </h2>
      }
      @case (4) {
        <h4>
          <ng-content></ng-content>
          @if (note) {
            <span class="nsc-card-title__note mat-caption">{{ note }}</span>
          }
        </h4>
      }
      @case (5) {
        <h5>
          <ng-content></ng-content>
          @if (note) {
            <span class="nsc-card-title__note mat-caption">{{ note }}</span>
          }
        </h5>
      }
      @case (6) {
        <h6>
          <ng-content></ng-content>
          @if (note) {
            <span class="nsc-card-title__note mat-caption">{{ note }}</span>
          }
        </h6>
      }
      @default {
        <!-- Fallback for level 3 (default) or any unexpected value -->
        <h3>
          <ng-content></ng-content>
          @if (note) {
            <span class="nsc-card-title__note mat-caption">{{ note }}</span>
          }
        </h3>
      }
    }
  </mat-card-title>
  @if (helpText) {
    <div class="nsc-card-title__help">
      <button type="button" mat-icon-button [attr.aria-label]="(helpTitle ? helpTitle + ' Information' : 'Information')" id="{{id}}_helpicon" (click)="openHelpDialog()">
        <mat-icon aria-hidden="true">info</mat-icon>
      </button>
    </div>
  }
</mat-card-header>
